module.exports = __webpack_public_path__ + "static/media/9.dc3b50d5.jpg";